<template>
  <div>
    <template v-if="showCavas">
      <section class="signature">
        <div class="signatureBox">
          <div class="canvasBox" ref="canvasHW">
            <canvas
              ref="canvasF"
              @touchstart="touchStart"
              @touchmove="touchMove"
              @touchend="touchEnd"
              @mousedown="mouseDown"
              @mousemove="mouseMove"
              @mouseup="mouseUp"
            ></canvas>
            <div class="btnBox">
              <el-button type="primary" @click="overwrite">重置内容</el-button>
              <el-button type="primary" @click="generateSign"
                >生成签名</el-button
              >
            </div>
          </div>
        </div>
        <!--        <img class="imgCanvas" :src="imgUrl">-->
      </section>
    </template>
    <template v-else>
      <div class="btnBox">
        <el-button type="primary" @click="startSign">点击开始签名</el-button>
        <el-button type="primary" @click="commit">提交签名</el-button>
      </div>
    </template>
  </div>
</template>

<script>
import { scpDealExpertWechatSignApi } from "@/app/sourcingFlow/api/scp-expertEvaluation.js";
// import wx from "weixin-js-sdk";

export default {
  name: "subExpertSign",
  data() {
    return {
      signContent: "",
      showCavas: false,
      stageInfo: "",
      imgUrl: "",
      client: {},
      points: [],
      canvasTxt: null,
      startX: 0,
      startY: 0,
      moveY: 0,
      moveX: 0,
      endY: 0,
      endX: 0,
      w: null,
      h: null,
      isDown: false,
      isViewAutograph: this.$route.query.isViews > 0,
      contractSuccess: this.$route.query.contractSuccess
    };
  },
  mounted() {},
  methods: {
    startSign() {
      this.showCavas = true;
      this.$nextTick(() => {
        let canvas = this.$refs.canvasF;
        canvas.height = this.$refs.canvasHW.offsetHeight - 87;
        canvas.width = this.$refs.canvasHW.offsetWidth - 2;
        this.canvasTxt = canvas.getContext("2d");
        this.stageInfo = canvas.getBoundingClientRect();
      });
    },
    touchStart(ev) {
      ev = ev || event;
      ev.preventDefault();
      if (ev.touches.length == 1) {
        let obj = {
          x: ev.targetTouches[0].clienX,
          y: ev.targetTouches[0].clientY
        };
        this.startX = obj.x;
        this.startY = obj.y;
        this.canvasTxt.beginPath();
        this.canvasTxt.moveTo(this.startX, this.startY);
      }
    },
    touchMove(ev) {
      ev = ev || event;
      ev.preventDefault();
      if (ev.touches.length == 1) {
        let obj = {
          x: ev.targetTouches[0].clientX - this.stageInfo.left,
          y: ev.targetTouches[0].clientY - this.stageInfo.top
        };
        this.moveY = obj.y;
        this.moveX = obj.x;
        this.canvasTxt.lineTo(obj.x, obj.y);
        this.canvasTxt.stroke();
      }
    },
    touchEnd(ev) {
      ev = ev || event;
      ev.preventDefault();
      if (ev.touches.length == 1) {
        this.canvasTxt.closePath();
      }
    },
    //pc
    mouseDown(ev) {
      ev = ev || event;
      ev.preventDefault();
      // 鼠标相对于事件源元素（srcElement）的X,Y坐标
      let obj = {
        x: ev.offsetX,
        y: ev.offsetY
      };
      this.startX = obj.x;
      this.startY = obj.y;
      // 起始一条路径，或重置当前路径
      this.canvasTxt.beginPath();
      // 把路径移动到画布中的指定点，不创建线条
      this.canvasTxt.moveTo(this.startX, this.startY);
      this.isDown = true;
    },
    mouseMove(ev) {
      ev = ev || event;
      ev.preventDefault();
      if (this.isDown) {
        let obj = {
          x: ev.offsetX,
          y: ev.offsetY
        };
        this.canvasTxt.lineTo(obj.x, obj.y);
        this.canvasTxt.stroke();
        this.startY = obj.y;
        this.startX = obj.x;
      }
    },
    mouseUp(ev) {
      ev = ev || event;
      ev.preventDefault();
      this.canvasTxt.closePath();
      this.isDown = false;
    },
    //重写
    overwrite() {
      this.canvasTxt.clearRect(
        0,
        0,
        this.$refs.canvasF.width,
        this.$refs.canvasF.height
      );
      this.points = [];
      this.imgUrl = "";
    },
    // 生成签名
    generateSign() {
      this.signContent = this.$refs.canvasF;
      this.showCavas = false;
    },
    //提交签名
    commit() {
      this.imgUrl = this.signContent.toDataURL();
      scpDealExpertWechatSignApi({
        schemeId: this.$route.query.schemeId,
        joinExpertId: this.$route.query.joinExpertId,
        pictureBase64: this.imgUrl
      }).then(res => {
        if (res) {
          // wx.closeWindow();
        } else {
          this.$message({
            message: res.msg,
            type: "eroor",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.signatureBox {
  width: 100%;
  height: calc(100% - 50px);
  box-sizing: border-box;
  overflow: hidden;
  background: #fff;
  z-index: 100;
  display: flex;
  flex-direction: column;
}
.canvasBox {
  box-sizing: border-box;
  flex: 1;
}
canvas {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
}
.btnBox {
  text-align: center;
}
</style>
